export default __webpack_public_path__ + "static/mosaic-dont-dark-4f1940254fa6dee6e71fc0f1f5dfc2e855930fb33d535a1587f86bfe2b745ecd.png";